/* ============================================================
   LALUAN POST FACEBOOK REELS (2026-09-26, keputusan user)
   'contentlibrary' (LALAI) — Professional Dashboard → Content Library → + Create → Reel
   'page'                   — page aktif → butang "Reel"

   KENAPA PELANGGAN MEMILIH: beg Shopee pada reel hanya kelihatan di PHONE, dan
   ia muncul ikut laluan — sesetengah page dapat beg melalui Content Library,
   yang lain hanya melalui butang "Reel" page. Dari PC tiada tanda beg itu, jadi
   robot tidak boleh memilih sendiri. Beralih laluan automatik (22 Sept) DIBUANG:
   laluan dipilih gagal = reel gagal + sebab, bukan reel tanpa beg secara senyap.

   Per-BROWSER (satu browser = satu page FB), sama seperti toggle Add product.

   ⭐ SAMPAI KE ROBOT TANPA ZIP BAHARU: dihantar dalam `tetapan.laluan` (payload
      SESAAT_DIRECT_FACEBOOK). ZIP 3.9.4 LIVE menyalin objek `tetapan` bulat-bulat
      (content.js → background → task.tetapan) — disahkan dengan membuka ZIP live
      26 Sept. ⚠️ KEMBAR: `laluanDipilih` dalam skrip remote facebook-reels.js
      (extension src/chrome) — nilai selain 'page' = Content Library di KEDUA-DUA.
   ============================================================ */

export const KUNCI_FB_LALUAN = 'sesaat_fb_laluan_v1';
export const LALUAN_FB = ['contentlibrary', 'page'];

export function bacaLaluanFb() {
    try { return localStorage.getItem(KUNCI_FB_LALUAN) === 'page' ? 'page' : 'contentlibrary'; } catch { return 'contentlibrary'; }
}

/* ⛔ Panggil dari PENGENDALI KLIK sahaja, bukan useEffect (perangkap nilai lalai
   tersimpan semasa mount — sama seperti tulisSuisProduk). */
export function tulisLaluanFb(laluan) {
    try { localStorage.setItem(KUNCI_FB_LALUAN, laluan === 'page' ? 'page' : 'contentlibrary'); } catch { /* storan ditutup — abai */ }
}
